import { useTranslate } from '@tolgee/react';

export function PartnerSectionWidget(props: Props) {
  const { t } = useTranslate();

  function Cursor() {
    return <div id={props.id} />;
  }

  if (!props.label) {
    return <Cursor />;
  }

  return (
    <div className="pt-8 pb-4">
      <Cursor />
      <h2 className="text-2xl font-bold">{t(props.label || '')}</h2>
    </div>
  );
}

interface Props {
  readonly id: string;
  readonly label: string;
}
